import { Action } from "redux";
import { createAction, ActionsUnion, ActionWithPayload } from "../utils/utils";




// ACTIONS TYPES
export enum PdApiActionsEnum {
  FETCH_DATA = "Fetch domains, faults, roles and parameters (saga)",
  FETCH_ALL_ON_CLICK = "Fetch All data on click (saga)",
  FETCH_PARAMETERS = "Fetch parameters (saga)",
  FETCH_FAULTS = "Fetch faults (saga)",
  FETCH_SIGNALS = "Fetch drive signals (saga)",
  FETCH_ESCALATOR_RTDs = "Fetch escalator RTDs (saga)",
  FETCH_ESCALATOR_RTD_GROUPS = "Fetch escalator RTD groups (saga)",
  FETCH_ESCALATOR_EVENT_LOGS = "Fetch escalator event logs (saga)",
  FETCH_STANDARD_BOARD = "Fetch standard board (saga)",
  FETCH_STANDARD_BOARDS_SHALLOW = "Fetch standard boards higher level (boardtype, revision, nodes) (saga)",
  FETCH_IO_CONFIGURATIONS_SHALLOW = "Fetch IO configurations (saga)",
  FETCH_ESCALATOR_PARAMETERS = "Fetch Escalator parameters (saga)",
  FETCH_APM_PARAMETERS = "Fetch APM parameters (saga)",
  FETCH_DRIVE_PARAMETERS = "Fetch Drive parameters (saga)",
  FETCH_APM_FAULTS = "Fetch APM faults (saga)",
  FETCH_ESCALATOR_FAULTS = "Fetch Escalator faults (saga)",
  FETCH_SIGNALIZATION_FAULTS = "Fetch Signalization faults (saga)",
  FETCH_IO_CONFIGURATION = "Fetch IO configuration by ID (saga)",
  FETCH_LOCALES = "Fetch locales (saga)",
  FETCH_SINGLE = "Fetch by ID (saga)",
  FETCH_CHARTDATA = "Fetch chart data (saga)",
  FETCH_TRANSLATION_LOG_ITEMS = "Fetch translation log items (saga)",
  TRANSLATION_LOG_ITEMS_LOADING = "Translation log fetch status (saga)",
  DOWNLOAD_LOCALIZATION_FILE = "Download Localization File (saga)",
  PUBLISH_LOCALIZATION_FILES = "Publish Localization Files (saga)",
  EXPORT_DEVELOPMENT_PACKAGE = "Export Development Package (saga)",
  DOWNLOAD_ESCALATOR_DEV_PACKAGE = "Download Escalator Development Package (saga)",
  CONVERT_BINARY_IOCONFFIG_TO_STRING = "Convert binary IO config to string (saga)",
  GENERATE_LICENSE_DATA = "Generate license data (saga)",
  GENERATE_ESCALATOR_LICENSE_DATA = "Generate escalator license data (saga)",
  GENERATE_DOOR_LICENSE_DATA = "Generate door license data (saga)",
  SET_DOMAIN_GROUPS = "Set domain groups",
  SET_DOMAINS = "Set domains",
  SET_FEATURES = "Set features",
  SET_FAULTS = "Set faults",
  SET_ESCALATOR_FAULTS = "Set escalator faults",
  SET_DOOR_FAULTS = "Set door faults",
  SET_NON_KONE_FAULTS = "Set non-Kone faults",
  SET_PARAMETERS = "Set parameters",
  SET_LIFT_PARAMETERS = "Set lift parameters",
  SET_DRIVE_PARAMETERS = "Set drive parameters",
  SET_GROUP_PARAMETERS = "Set group parameters",
  SET_SAFETY_PARAMETERS = "Set safety parameters",
  SET_DOOR_PARAMETERS = "Set door parameters",
  SET_APM_PARAMETERS = "Set apm parameters",
  SET_APM_FAULTS = "Set apm faults",
  SET_SIGNALIZATION_FAULTS = "Set signalization faults",
  SET_ESCALATOR_PARAMETERS = "Set escalator parameters",
  SET_FAULT_PRIORITIES = "Set fault priorities",
  SET_PARAMETER_CATEGORIES = "Set parameter categories",
  SET_FAULT_CATEGORIES = "Set fault categories",
  SET_USERS = "Set users",
  SET_USER_GROUPS = "Set user groups",
  SET_ROLES = "Set roles",
  SET_ENUMERATION_GROUPS = "Set enumeration groups",
  SET_FAULT_COMPONENTS = "Set fault components",
  SET_KCE_VERSIONS = "Set kce versions",
  SET_KCE_PRODUCTS = "Set kce products",
  SET_DRIVE_VERSIONS = "Set drive versions",
  SET_DRIVE_SIGNALS = "Set drive signals",
  SET_DRIVE_TESTS = "Set drive tests",
  SET_DRIVE_SIGNAL_GROUPS = "Set drive signal groups",
  SET_ESCALATOR_RTDS = "Set escalator RTDs",
  SET_ESCALATOR_RTD_GROUPS = "Set escalator RTD groups",
  SET_ESCALATOR_EVENT_LOGS = "Set escalator event logs",
  SET_EVENT_CLASSES = "Set event classes",
  SET_EVENT_TYPES = "Set event types",
  SET_EVENT_PIDS = "Set event pids",
  SET_EXT_COMMANDS = "Set ext commands",
  SET_MESSAGE_TYPES = "Set message types",
  SET_IO_BOARD_TYPES = "Set io board types",
  SET_IO_CPUS = "Set io cpues",
  SET_IO_NETWORKS = "Set io networks",
  SET_IO_OPTIONS = "Set ext io options",
  SET_IO_ENUMTYPE = "Set ext io EnumType",
  SET_IO_DATATYPES = "Set io datatypes",
  SET_IO_BASIC_DATATYPES = "Set io basicdatatypes",
  SET_IO_DATA_SECTIONS = "Set io data sections",
  SET_COMMONENUMERATIONS = "Set common enumerations",
  SET_COMMONENUMERATIONITEMS = "Set common enumeration items",
  SET_STANDARD_BOARDS = "Set standard boards",
  SET_DECKS = "Set action decks",
  SET_SIDES = "Set action sides",
  SET_LOADING_PARAMETERS = "Set loading status for parameteres",
  ESCALATOR_PARAMETERS_LOADING = "Set loading status for escalator parameteres",
  ESCALATOR_FAULT_LOADING = "Set loading status for escalator faults",
  ESCALATOR_RTDS_LOADING = "Set loading status for escalator RTDs",
  ESCALATOR_RTD_GROUPS_LOADING = "Set loading status for escalator RTD groups",
  ESCALATOR_EVENT_LOGS_LOADING = "Set loading status for escalator event logs",
  APM_PARAMETERS_LOADING = "Set loading status for apm parameteres",
  APM_FAULTS_LOADING = "Set loading status for apm faults",
  SIGNALIZATION_FAULTS_LOADING = "Set loading status for signalization faults",
  DRIVE_FAULTS_LOADING = "Set loading status for drive faults",
  DRIVE_PARAMETERS_LOADING = "Set loading status for drive parameters",
  LIFT_FAULTS_LOADING = "Set loading status for lift faults",
  GROUP_FAULTS_LOADING = "Set loading status for group faults",
  NETWORK_FAULTS_LOADING = "Set loading status for network faults",
  MONITORING_FAULTS_LOADING = "Set loading status for monitoring faults",
  ESCALATOR_EVENT_LOADING = "Set loading status for escalator events",
  SET_LOADING_FAULTS = "Set loading status for faults",
  SET_LOADING_STATISTICS = "Set loading status for statistics",
  SET_PUBLISHING_LOCALIZATIONS = "Set publishing status for localizations",
  LOCALIZATION_PUBLISH_SUCCEEDED = "Localization publish succeeded",
  SET_EXPORTING_DEVELOPMENT_PACKAGE = "Set exporting status for development package",
  SET_DOWNLOADING_ESCALATOR_DEV_PACKAGE = "Set downloading status for escalator development package",
  SET_ELECTRIFICATIONS = "Set electrifications",
  SET_FILTER_OPTIONS = "Set filter options",
  SET_TRANSLATION_STATUS_FILTER_OPTIONS = "Set translation status filter options",
  SET_AAD_GROUPS = "Set aad groups",
  SET_LOCALES = "Set locales",
  SET_TRANSLATION_LOG_ITEMS = "Set translation log items",
  SET_TRANSLATION_SUMMARY = "Set translation summary",
  SET_LANGUAGE_COVERAGE = "Set language coverage",
  SET_ITEMTYPE_LANGUAGE_COVERAGE = "Set item type language coverage",
  SET_LICENSE_GENERATION = "Set license generation status",
  DOOR_EVENT_LOADING = "Set loading status for door events",
  SET_DOOR_EVENT_CLASSES = "Set door event classes",
  SET_DOOR_EVENT_TYPES = "Set door event types",
  SET_DOOR_EVENT_PIDS = "Set door event pids",
  SET_DOOR_EXT_COMMANDS = "Set door ext commands",
  FETCH_DOOR_EVENT_CLASSES = "Fetch door event classes",
  SET_ESCALATOR_EVENT_CLASSES = "Set escalator event classes",
  SET_ESCALATOR_EVENT_TYPES = "Set escalator event types",
  SET_ESCALATOR_EVENT_PIDS = "Set escalator event pids",
  SET_ESCALATOR_EXT_COMMAND = "Set escalator ext command",
  SET_ESCALATOR_REQUEST_TYPES = "Set escalator request types",
  FETCH_ESCALATOR_EVENT_CLASSES = "Fetch escalator event classes",
  FETCH_DOOR_BINDINDS = "Fetch door bindings",
  SET_DOOR_VERSIONS = "Set door versions",
  DOOR_BINDINGS_LOADING = "Set loading status for door bindings",
  FETCH_ESCALATOR_VERSIONS = "Fetch escalator versions",
  ESCALATOR_VERSIONS_LOADING = "Set loading status for escalator versions",
  SET_ESCALATOR_VERSIONS = "Set escalator versions",
  SET_DRIVE_FAULTS = "Set drive faults",
  FETCH_DRIVE_FAULTS = "Fetch drive faults",
  SET_LIFT_FAULTS = "Set lift faults",
  FETCH_LIFT_FAULTS = "Fetch lift faults",
  SET_GROUP_FAULTS = "Set group faults",
  FETCH_GROUP_FAULTS = "Fetch group faults",
  SET_NETWORK_FAULTS = "Set network faults",
  FETCH_NETWORK_FAULTS = "Fetch network faults",
  SET_MONITORING_FAULTS = "Set monitoring faults",
  FETCH_MONITORING_FAULTS = "Fetch monitoring faults",
  SET_MONITORING_FAULT_CATEGORIES = "Set monitoring fault categories",
  FETCH_MONITORING_FAULT_CATEGORIES = "Fetch monitoring fault categories",
  MONITORING_FAULT_CATEGORIES_LOADING = "Set loading status for monitoring fault categories",
  SET_DATAACT_CODES = "Set data act codes",
  FETCH_DATA_ACT_CODES = "Fetch data act codes",
  DATAACT_CODE_LOADING = "Set loading status for data act codes",
  SET_ESCALATOR_DATAACT_CODES = "Set escalator data act codes",
  FETCH_ESCALATOR_DATAACT_CODES = "Fetch escalator data act codes",
  ESCALATOR_DATAACT_CODE_LOADING = "Set loading status for escalator data act codes",
  SET_GRAND_NORMS = "Set grand norms",
  FETCH_GRAND_NORMS = "Fetch grand norms",
  GRAND_NORMS_LOADING = "Set loading status for grand norms",
  UPLOAD_TLG_QA = "Upload to TLG QA (saga)",
  UPLOAD_TLG_QA_SUCCESS = "Upload to TLG QA success",
  UPLOAD_TLG_QA_FAILURE = "Upload to TLG QA failure",
  FETCH_LICENSE_RECORD = "Fetch license record (saga)",
  FETCH_LICENSE_RECORD_SUCCESS = "Fetch license record success",
  FETCH_LICENSE_RECORD_FAILURE = "Fetch license record failure",
  PUSH_TO_PROD = "Push to TLG Prod (saga)",
  PUSH_TO_PROD_SUCCESS = "Push to TLG Prod success",
  PUSH_TO_PROD_FAILURE = "Push to TLG Prod failure",
  REQUEST_LOTA = "Request LOTA push (saga)",
  REQUEST_LOTA_SUCCESS = "Request LOTA push success",
  REQUEST_LOTA_FAILURE = "Request LOTA push failure",
  APPROVE_LOTA = "Approve LOTA push (saga)",
  APPROVE_LOTA_SUCCESS = "Approve LOTA push success",
  APPROVE_LOTA_FAILURE = "Approve LOTA push failure",
  REJECT_LOTA = "Reject LOTA push (saga)",
  REJECT_LOTA_SUCCESS = "Reject LOTA push success",
  REJECT_LOTA_FAILURE = "Reject LOTA push failure",
  SET_LICENSE_DEVICE_TYPE = "Set license upload device type",
  SET_LICENSE_USER_GROUP = "Set license upload user group"
}

// ACTION CREATORS
export const pdApiActions = {
  fetchParameters: (): Action<PdApiActionsEnum.FETCH_PARAMETERS> =>
    createAction(PdApiActionsEnum.FETCH_PARAMETERS),
  fetchFaults: (): Action<PdApiActionsEnum.FETCH_FAULTS> =>
    createAction(PdApiActionsEnum.FETCH_FAULTS),
  fetchData: (): Action<PdApiActionsEnum.FETCH_DATA> => createAction(PdApiActionsEnum.FETCH_DATA),
  fetchAllOnClick: (): Action<PdApiActionsEnum.FETCH_ALL_ON_CLICK> => createAction(PdApiActionsEnum.FETCH_ALL_ON_CLICK),
  fetchSignals: (): Action<PdApiActionsEnum.FETCH_SIGNALS> =>
    createAction(PdApiActionsEnum.FETCH_SIGNALS),
  fetchEscalatorRTDs: (): Action<PdApiActionsEnum.FETCH_ESCALATOR_RTDs> =>
    createAction(PdApiActionsEnum.FETCH_ESCALATOR_RTDs),
  fetchEscalatorRTDGroups: (): Action<PdApiActionsEnum.FETCH_ESCALATOR_RTD_GROUPS> =>
    createAction(PdApiActionsEnum.FETCH_ESCALATOR_RTD_GROUPS),
  fetchEscalatorEventLogs: (): Action<PdApiActionsEnum.FETCH_ESCALATOR_EVENT_LOGS> =>
    createAction(PdApiActionsEnum.FETCH_ESCALATOR_EVENT_LOGS),
  fetchStandardBoard: (
    id: string
  ): ActionWithPayload<PdApiActionsEnum.FETCH_STANDARD_BOARD, string> =>
    createAction(PdApiActionsEnum.FETCH_STANDARD_BOARD, id),
  fetchStandardBoardsShallow: (): Action<PdApiActionsEnum.FETCH_STANDARD_BOARDS_SHALLOW> =>
    createAction(PdApiActionsEnum.FETCH_STANDARD_BOARDS_SHALLOW),
  fetchIoConfigurations: (): Action<PdApiActionsEnum.FETCH_IO_CONFIGURATIONS_SHALLOW> =>
    createAction(PdApiActionsEnum.FETCH_IO_CONFIGURATIONS_SHALLOW),
  fetchEscalatorParameters: (): Action<PdApiActionsEnum.FETCH_ESCALATOR_PARAMETERS> =>
    createAction(PdApiActionsEnum.FETCH_ESCALATOR_PARAMETERS),
  fetchEscalatorFaults: (): Action<PdApiActionsEnum.FETCH_ESCALATOR_FAULTS> =>
    createAction(PdApiActionsEnum.FETCH_ESCALATOR_FAULTS),
  fetchAPMParamters: (): Action<PdApiActionsEnum.FETCH_APM_PARAMETERS> =>
    createAction(PdApiActionsEnum.FETCH_APM_PARAMETERS),
    fetchDriveParameters: (): Action<PdApiActionsEnum.FETCH_DRIVE_PARAMETERS> =>
    createAction(PdApiActionsEnum.FETCH_DRIVE_PARAMETERS),
  fetchAPMFaults: (): Action<PdApiActionsEnum.FETCH_APM_FAULTS> =>
    createAction(PdApiActionsEnum.FETCH_APM_FAULTS),
  fetchSignalizationFaults: (): Action<PdApiActionsEnum.FETCH_SIGNALIZATION_FAULTS> =>
    createAction(PdApiActionsEnum.FETCH_SIGNALIZATION_FAULTS),
  fetchDriveFaults: (): Action<PdApiActionsEnum.FETCH_DRIVE_FAULTS> =>
    createAction(PdApiActionsEnum.FETCH_DRIVE_FAULTS),
  fetchLiftFaults: (): Action<PdApiActionsEnum.FETCH_LIFT_FAULTS> =>
    createAction(PdApiActionsEnum.FETCH_LIFT_FAULTS),
  fetchGroupFaults: (): Action<PdApiActionsEnum.FETCH_GROUP_FAULTS> =>
    createAction(PdApiActionsEnum.FETCH_GROUP_FAULTS),
  fetchNetworkFaults: (): Action<PdApiActionsEnum.FETCH_NETWORK_FAULTS> =>
    createAction(PdApiActionsEnum.FETCH_NETWORK_FAULTS),
  fetchMonitoringFaults: (): Action<PdApiActionsEnum.FETCH_MONITORING_FAULTS> =>
    createAction(PdApiActionsEnum.FETCH_MONITORING_FAULTS),
  fetchMonitoringFaultCategories: (): Action<PdApiActionsEnum.FETCH_MONITORING_FAULT_CATEGORIES> =>
    createAction(PdApiActionsEnum.FETCH_MONITORING_FAULT_CATEGORIES),
  monitoringFaultsLoadingStatus: (
    status: boolean
  ): ActionWithPayload<PdApiActionsEnum.MONITORING_FAULTS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.MONITORING_FAULTS_LOADING, status),
  monitoringFaultCategoriesLoadingStatus: (
    status: boolean
  ): ActionWithPayload<PdApiActionsEnum.MONITORING_FAULT_CATEGORIES_LOADING, boolean> =>
    createAction(PdApiActionsEnum.MONITORING_FAULT_CATEGORIES_LOADING, status),
  fetchEscalatorEvent: (type: string): ActionWithPayload<PdApiActionsEnum.FETCH_ESCALATOR_EVENT_CLASSES, string> =>
    createAction(PdApiActionsEnum.FETCH_ESCALATOR_EVENT_CLASSES, type),
  fetchEscalatorVersions: (type: string): ActionWithPayload<PdApiActionsEnum.FETCH_ESCALATOR_VERSIONS, string> =>
    createAction(PdApiActionsEnum.FETCH_ESCALATOR_VERSIONS, type),
  fetchDoorBindings: (type: string): ActionWithPayload<PdApiActionsEnum.FETCH_DOOR_BINDINDS, string> =>
    createAction(PdApiActionsEnum.FETCH_DOOR_BINDINDS, type),
  fetchDoorEvent: (type: string): ActionWithPayload<PdApiActionsEnum.FETCH_DOOR_EVENT_CLASSES, string> =>
    createAction(PdApiActionsEnum.FETCH_DOOR_EVENT_CLASSES, type),
  fetchEscalatorDataActCodes: (): Action<PdApiActionsEnum.FETCH_ESCALATOR_DATAACT_CODES> =>
    createAction(PdApiActionsEnum.FETCH_ESCALATOR_DATAACT_CODES),
  fetchGrandNorms: (): Action<PdApiActionsEnum.FETCH_GRAND_NORMS> =>
    createAction(PdApiActionsEnum.FETCH_GRAND_NORMS),
  fetchLocales: (): Action<PdApiActionsEnum.FETCH_LOCALES> =>
    createAction(PdApiActionsEnum.FETCH_LOCALES),
  fetchSingle: (
    option: Api.OptionsGet,
    id: string
  ): ActionWithPayload<PdApiActionsEnum.FETCH_SINGLE, { option: Api.OptionsGet; id: string }> =>
    createAction(PdApiActionsEnum.FETCH_SINGLE, { option, id }),
  fetchChartDataSingle: (
    option: Api.OptionsGetChartData,
    domainGroup: number,
    itemType: number,
    domain: number
  ): ActionWithPayload<
    PdApiActionsEnum.FETCH_CHARTDATA,
    { option: Api.OptionsGetChartData; domainGroup: number; itemType: number; domain: number }
  > =>
    createAction(PdApiActionsEnum.FETCH_CHARTDATA, {
      option,
      domainGroup,
      itemType,
      domain
    }),
  setTranslationLogLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.TRANSLATION_LOG_ITEMS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.TRANSLATION_LOG_ITEMS_LOADING, isLoading),
  fetchTranslationLogItems: (): Action<PdApiActionsEnum.FETCH_TRANSLATION_LOG_ITEMS> =>
    createAction(PdApiActionsEnum.FETCH_TRANSLATION_LOG_ITEMS),
  downloadLocalizationFile: (
    selectedDomainGroup: string,
    selectedLocale: string
  ): ActionWithPayload<
    PdApiActionsEnum.DOWNLOAD_LOCALIZATION_FILE,
    { selectedDomainGroup: string; selectedLocale: string }
  > =>
    createAction(PdApiActionsEnum.DOWNLOAD_LOCALIZATION_FILE, {
      selectedDomainGroup,
      selectedLocale
    }),
  publishLocalizationFiles: (): Action<PdApiActionsEnum.PUBLISH_LOCALIZATION_FILES> =>
    createAction(PdApiActionsEnum.PUBLISH_LOCALIZATION_FILES),

  generateLicenseData: (): Action<PdApiActionsEnum.GENERATE_LICENSE_DATA> =>
    createAction(PdApiActionsEnum.GENERATE_LICENSE_DATA),

  generateEscalatorLicenseData: (): Action<PdApiActionsEnum.GENERATE_ESCALATOR_LICENSE_DATA> =>
    createAction(PdApiActionsEnum.GENERATE_ESCALATOR_LICENSE_DATA),

  generateDoorLicenseData: (): Action<PdApiActionsEnum.GENERATE_DOOR_LICENSE_DATA> =>
    createAction(PdApiActionsEnum.GENERATE_DOOR_LICENSE_DATA),

  exportDevelopmentPackage: (
    developmentPackage: Api.DevelopmentPackage
  ): ActionWithPayload<PdApiActionsEnum.EXPORT_DEVELOPMENT_PACKAGE, Api.DevelopmentPackage> =>
    createAction(PdApiActionsEnum.EXPORT_DEVELOPMENT_PACKAGE, developmentPackage),
  convertBinaryIoConfigToString: (
    binaryIoConfig: ArrayBuffer
  ): ActionWithPayload<PdApiActionsEnum.CONVERT_BINARY_IOCONFFIG_TO_STRING, ArrayBuffer> =>
    createAction(PdApiActionsEnum.CONVERT_BINARY_IOCONFFIG_TO_STRING, binaryIoConfig),
  downloadEscalatorDevPackage: (
    escalatorDevPackage: Api.EscalatorDevPackage
  ): ActionWithPayload<PdApiActionsEnum.DOWNLOAD_ESCALATOR_DEV_PACKAGE, Api.EscalatorDevPackage> =>
    createAction(PdApiActionsEnum.DOWNLOAD_ESCALATOR_DEV_PACKAGE, escalatorDevPackage),
  setDomainGroups: (
    domainGroups: Api.DomainGroup[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DOMAIN_GROUPS, Api.DomainGroup[]> =>
    createAction(PdApiActionsEnum.SET_DOMAIN_GROUPS, domainGroups),
  setDomains: (domains: Api.Domain[]): ActionWithPayload<PdApiActionsEnum.SET_DOMAINS, Api.Domain[]> => createAction(PdApiActionsEnum.SET_DOMAINS, domains),
  setFaults: (faults: Api.AnyFault[]): ActionWithPayload<PdApiActionsEnum.SET_FAULTS, Api.AnyFault[]> => createAction(PdApiActionsEnum.SET_FAULTS, faults),
  setEscalatorFaults: (escalatorFaults: Api.EscalatorFault[]): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_FAULTS, Api.EscalatorFault[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_FAULTS, escalatorFaults),
  setDoorFaults: (doorFaults: Api.DoorFault[]): ActionWithPayload<PdApiActionsEnum.SET_DOOR_FAULTS, Api.DoorFault[]> =>
    createAction(PdApiActionsEnum.SET_DOOR_FAULTS, doorFaults),
  setNonKoneFaults: (nonKoneFaults: Api.NonKoneFault[]): ActionWithPayload<PdApiActionsEnum.SET_NON_KONE_FAULTS, Api.NonKoneFault[]> =>
    createAction(PdApiActionsEnum.SET_NON_KONE_FAULTS, nonKoneFaults),
  setFeatures: (
    features: Api.Feature[]
  ): ActionWithPayload<PdApiActionsEnum.SET_FEATURES, Api.Feature[]> =>
    createAction(PdApiActionsEnum.SET_FEATURES, features),
  setParameters: (
    parameters: Api.AnyParameter[]
  ): ActionWithPayload<PdApiActionsEnum.SET_PARAMETERS, Api.AnyParameter[]> =>
    createAction(PdApiActionsEnum.SET_PARAMETERS, parameters),
  setLiftParameters: (
    parameters: Api.LiftParameter[]
  ): ActionWithPayload<PdApiActionsEnum.SET_LIFT_PARAMETERS, Api.LiftParameter[]> =>
    createAction(PdApiActionsEnum.SET_LIFT_PARAMETERS, parameters),
  setDriveParameters: (
    parameters: Api.DriveParameter[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DRIVE_PARAMETERS, Api.DriveParameter[]> =>
    createAction(PdApiActionsEnum.SET_DRIVE_PARAMETERS, parameters),
  setGroupParameters: (
    parameters: Api.GroupParameter[]
  ): ActionWithPayload<PdApiActionsEnum.SET_GROUP_PARAMETERS, Api.GroupParameter[]> =>
    createAction(PdApiActionsEnum.SET_GROUP_PARAMETERS, parameters),
  setSafetyParameters: (
    parameters: Api.SafetyParameter[]
  ): ActionWithPayload<PdApiActionsEnum.SET_SAFETY_PARAMETERS, Api.BaseParameter[]> =>
    createAction(PdApiActionsEnum.SET_SAFETY_PARAMETERS, parameters),
  setEscalatorParameters: (
    parameters: Api.EscalatorParameter[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_PARAMETERS, Api.BaseParameter[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_PARAMETERS, parameters),
  setDoorParameters: (
    parameters: Api.DoorParameter[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DOOR_PARAMETERS, Api.BaseParameter[]> =>
    createAction(PdApiActionsEnum.SET_DOOR_PARAMETERS, parameters),
  setAPMParameters: (
    parameters: Api.ApmParamters[]
  ): ActionWithPayload<PdApiActionsEnum.SET_APM_PARAMETERS, Api.BaseParameter[]> =>
    createAction(PdApiActionsEnum.SET_APM_PARAMETERS, parameters),
  setAPMFaults: (
    faults: Api.APMFault[]
  ): ActionWithPayload<PdApiActionsEnum.SET_APM_FAULTS, Api.BaseFault[]> =>
    createAction(PdApiActionsEnum.SET_APM_FAULTS, faults),
  setDriveFaults: (
    faults: Api.DriveFault[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DRIVE_FAULTS, Api.BaseFault[]> =>
    createAction(PdApiActionsEnum.SET_DRIVE_FAULTS, faults),
  setLiftFaults: (
    faults: Api.LiftFault[]
  ): ActionWithPayload<PdApiActionsEnum.SET_LIFT_FAULTS, Api.BaseFault[]> =>
    createAction(PdApiActionsEnum.SET_LIFT_FAULTS, faults),
  setSignalizationFaults: (
    faults: Api.SignalizationFault[]
  ): ActionWithPayload<PdApiActionsEnum.SET_SIGNALIZATION_FAULTS, Api.BaseFault[]> =>
    createAction(PdApiActionsEnum.SET_SIGNALIZATION_FAULTS, faults),
  setDataActCodes: (
    dataActCodes: Api.DataActCode[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DATAACT_CODES, Api.DataActCode[]> =>
    createAction(PdApiActionsEnum.SET_DATAACT_CODES, dataActCodes),
  setEscalatorDataActCodes: (
    escalatorDataActCodes: Api.EscalatorDataActCode[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_DATAACT_CODES, Api.EscalatorDataActCode[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_DATAACT_CODES, escalatorDataActCodes),
  setGrandNorms: (
    grandNorms: Api.GrandNorm[]
  ): ActionWithPayload<PdApiActionsEnum.SET_GRAND_NORMS, Api.GrandNorm[]> =>
    createAction(PdApiActionsEnum.SET_GRAND_NORMS, grandNorms),
  setGroupFaults: (
    faults: Api.GroupFault[]
  ): ActionWithPayload<PdApiActionsEnum.SET_GROUP_FAULTS, Api.BaseFault[]> =>
    createAction(PdApiActionsEnum.SET_GROUP_FAULTS, faults),
  setNetworkFaults: (
    faults: Api.NetworkFault[]
  ): ActionWithPayload<PdApiActionsEnum.SET_NETWORK_FAULTS, Api.BaseFault[]> =>
    createAction(PdApiActionsEnum.SET_NETWORK_FAULTS, faults),
  setMonitoringFaults: (
    faults: Api.MonitoringFault[]
  ): ActionWithPayload<PdApiActionsEnum.SET_MONITORING_FAULTS, Api.BaseFault[]> =>
    createAction(PdApiActionsEnum.SET_MONITORING_FAULTS, faults),
  setMonitoringFaultCategories: (
    monitoringFaultCategories: Api.FaultCategory[]
  ): ActionWithPayload<PdApiActionsEnum.SET_MONITORING_FAULT_CATEGORIES, Api.FaultCategory[]> =>
    createAction(PdApiActionsEnum.SET_MONITORING_FAULT_CATEGORIES, monitoringFaultCategories),
  setFaultPriorities: (
    faultPriorities: Api.FaultPriority[]
  ): ActionWithPayload<PdApiActionsEnum.SET_FAULT_PRIORITIES, Api.FaultPriority[]> =>
    createAction(PdApiActionsEnum.SET_FAULT_PRIORITIES, faultPriorities),
  setParameterCategories: (
    parameterCategories: Api.ParameterCategory[]
  ): ActionWithPayload<PdApiActionsEnum.SET_PARAMETER_CATEGORIES, Api.ParameterCategory[]> =>
    createAction(PdApiActionsEnum.SET_PARAMETER_CATEGORIES, parameterCategories),
  setFaultCategories: (
    faultCategories: Api.FaultCategory[]
  ): ActionWithPayload<PdApiActionsEnum.SET_FAULT_CATEGORIES, Api.FaultCategory[]> =>
    createAction(PdApiActionsEnum.SET_FAULT_CATEGORIES, faultCategories),
  setRoles: (roles: Api.Role[]): ActionWithPayload<PdApiActionsEnum.SET_ROLES, Api.Role[]> =>
    createAction(PdApiActionsEnum.SET_ROLES, roles),
  setUserGroups: (
    userGroups: Api.UserGroup[]
  ): ActionWithPayload<PdApiActionsEnum.SET_USER_GROUPS, Api.UserGroup[]> =>
    createAction(PdApiActionsEnum.SET_USER_GROUPS, userGroups),
  setUsers: (users: Api.User[]): ActionWithPayload<PdApiActionsEnum.SET_USERS, Api.User[]> =>
    createAction(PdApiActionsEnum.SET_USERS, users),
  setEnumerationGroups: (
    enumerationGroups: Api.EnumerationGroup[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ENUMERATION_GROUPS, Api.EnumerationGroup[]> =>
    createAction(PdApiActionsEnum.SET_ENUMERATION_GROUPS, enumerationGroups),
  setFaultComponents: (
    faultComponents: Api.FaultComponentEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_FAULT_COMPONENTS, Api.FaultComponentEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_FAULT_COMPONENTS, faultComponents),
  setKceVersions: (
    kceVersions: Api.KceVersion[]
  ): ActionWithPayload<PdApiActionsEnum.SET_KCE_VERSIONS, Api.KceVersion[]> =>
    createAction(PdApiActionsEnum.SET_KCE_VERSIONS, kceVersions),
  setKceProducts: (
    kceProducts: Api.KceProduct[]
  ): ActionWithPayload<PdApiActionsEnum.SET_KCE_PRODUCTS, Api.KceProduct[]> =>
    createAction(PdApiActionsEnum.SET_KCE_PRODUCTS, kceProducts),
  setDriveVersions: (
    driveVersions: Api.DriveVersion[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DRIVE_VERSIONS, Api.DriveVersion[]> =>
    createAction(PdApiActionsEnum.SET_DRIVE_VERSIONS, driveVersions),
  setDriveSignals: (
    driveSignals: Api.DriveSignal[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DRIVE_SIGNALS, Api.DriveSignal[]> =>
    createAction(PdApiActionsEnum.SET_DRIVE_SIGNALS, driveSignals),
  setDriveTests: (
    driveTests: Api.DriveTest[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DRIVE_TESTS, Api.DriveTest[]> =>
    createAction(PdApiActionsEnum.SET_DRIVE_TESTS, driveTests),
  setDriveSignalGroups: (
    signalGroups: Api.DriveSignalGroup[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DRIVE_SIGNAL_GROUPS, Api.DriveSignalGroup[]> =>
    createAction(PdApiActionsEnum.SET_DRIVE_SIGNAL_GROUPS, signalGroups),
  setEscalatorRTDs: (
    escalatorRTDs: Api.EscalatorRTD[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_RTDS, Api.EscalatorRTD[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_RTDS, escalatorRTDs),
  setEscalatorRTDGroups: (
    escalatorRTDGroups: Api.EscalatorRTDGroup[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_RTD_GROUPS, Api.EscalatorRTDGroup[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_RTD_GROUPS, escalatorRTDGroups),
  setEscalatorEventLogs: (
    escalatorEventLogs: Api.EscalatorEventLog[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_EVENT_LOGS, Api.EscalatorEventLog[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_EVENT_LOGS, escalatorEventLogs),
  setEventClasses: (
    eventClasses: Api.LiftEventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_EVENT_CLASSES, Api.LiftEventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_EVENT_CLASSES, eventClasses),
  setEventTypes: (
    eventTypes: Api.LiftEventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_EVENT_TYPES, Api.LiftEventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_EVENT_TYPES, eventTypes),
  setEventPids: (
    eventPids: Api.LiftEventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_EVENT_PIDS, Api.LiftEventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_EVENT_PIDS, eventPids),
  setExtCommands: (
    extCommands: Api.LiftEventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_EXT_COMMANDS, Api.LiftEventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_EXT_COMMANDS, extCommands),
  setMessageTypes: (
    messageTypes: Api.MessageType[]
  ): ActionWithPayload<PdApiActionsEnum.SET_MESSAGE_TYPES, Api.MessageType[]> =>
    createAction(PdApiActionsEnum.SET_MESSAGE_TYPES, messageTypes),
  setIOBoardTypes: (
    ioBoardType: Api.IoBoardType[]
  ): ActionWithPayload<PdApiActionsEnum.SET_IO_BOARD_TYPES, Api.IoBoardType[]> =>
    createAction(PdApiActionsEnum.SET_IO_BOARD_TYPES, ioBoardType),
  setIOCpus: (
    ioCpu: Api.BaseEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_IO_CPUS, Api.BaseEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_IO_CPUS, ioCpu),
  setIONetwork: (
    ioNetwork: Api.BaseEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_IO_NETWORKS, Api.BaseEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_IO_NETWORKS, ioNetwork),
  setIOOptions: (
    ioOption: Api.ioOption[]
  ): ActionWithPayload<PdApiActionsEnum.SET_IO_OPTIONS, Api.ioOption[]> =>
    createAction(PdApiActionsEnum.SET_IO_OPTIONS, ioOption),
  setIODatatypes: (
    ioDatatype: Api.ioDataType[]
  ): ActionWithPayload<PdApiActionsEnum.SET_IO_DATATYPES, Api.ioDataType[]> =>
    createAction(PdApiActionsEnum.SET_IO_DATATYPES, ioDatatype),
  setIODataSections: (
    iodataSections: Api.IodataSections[]
  ): ActionWithPayload<PdApiActionsEnum.SET_IO_DATA_SECTIONS, Api.IodataSections[]> =>
    createAction(PdApiActionsEnum.SET_IO_DATA_SECTIONS, iodataSections),
  setIOEnumOptionsType: (
    iooptionEnumType: Api.IoOptionsEnumType[]
  ): ActionWithPayload<PdApiActionsEnum.SET_IO_ENUMTYPE, Api.IoOptionsEnumType[]> =>
    createAction(PdApiActionsEnum.SET_IO_ENUMTYPE, iooptionEnumType),
  setCommonEnumerations: (
    enumerations: Api.CommonEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_COMMONENUMERATIONS, Api.CommonEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_COMMONENUMERATIONS, enumerations),
  setCommonEnumerationItems: (
    enumerationItems: Api.CommonEnumerationItem[]
  ): ActionWithPayload<PdApiActionsEnum.SET_COMMONENUMERATIONITEMS, Api.CommonEnumerationItem[]> =>
    createAction(PdApiActionsEnum.SET_COMMONENUMERATIONITEMS, enumerationItems),
  setIOBasicDatatypes: (
    ioBasicDatatype: Api.IoBasicDataType[]
  ): ActionWithPayload<PdApiActionsEnum.SET_IO_BASIC_DATATYPES, Api.IoBasicDataType[]> =>
    createAction(PdApiActionsEnum.SET_IO_BASIC_DATATYPES, ioBasicDatatype),
  setStandardBoards: (
    StandardBoards: Api.StandardBoard[]
  ): ActionWithPayload<PdApiActionsEnum.SET_STANDARD_BOARDS, Api.StandardBoard[]> =>
    createAction(PdApiActionsEnum.SET_STANDARD_BOARDS, StandardBoards),
  setDecks: (
    decks: Api.BaseEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DECKS, Api.BaseEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_DECKS, decks),
  setSides: (
    sides: Api.BaseEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_SIDES, Api.BaseEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_SIDES, sides),
  setParametersLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.SET_LOADING_PARAMETERS, boolean> =>
    createAction(PdApiActionsEnum.SET_LOADING_PARAMETERS, isLoading),
  escalatorParaLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.ESCALATOR_PARAMETERS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.ESCALATOR_PARAMETERS_LOADING, isLoading),
  escalatorFaultLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.ESCALATOR_FAULT_LOADING, boolean> =>
    createAction(PdApiActionsEnum.ESCALATOR_FAULT_LOADING, isLoading),
  apmParaLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.APM_PARAMETERS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.APM_PARAMETERS_LOADING, isLoading),
  apmFaultsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.APM_FAULTS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.APM_FAULTS_LOADING, isLoading),
  signalizationFaultsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.SIGNALIZATION_FAULTS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.SIGNALIZATION_FAULTS_LOADING, isLoading),
  driveFaultsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.DRIVE_FAULTS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.DRIVE_FAULTS_LOADING, isLoading),
  driveParametersLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.DRIVE_PARAMETERS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.DRIVE_PARAMETERS_LOADING, isLoading),
  liftFaultsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.LIFT_FAULTS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.LIFT_FAULTS_LOADING, isLoading),
  groupFaultsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.GROUP_FAULTS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.GROUP_FAULTS_LOADING, isLoading),
  networkFaultsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.NETWORK_FAULTS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.NETWORK_FAULTS_LOADING, isLoading),
  escalatorEventLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.ESCALATOR_EVENT_LOADING, boolean> =>
    createAction(PdApiActionsEnum.ESCALATOR_EVENT_LOADING, isLoading),
  escalatorVersionsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.ESCALATOR_VERSIONS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.ESCALATOR_VERSIONS_LOADING, isLoading),
  doorBindingsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.DOOR_BINDINGS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.DOOR_BINDINGS_LOADING, isLoading),
  doorEventLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.DOOR_EVENT_LOADING, boolean> =>
    createAction(PdApiActionsEnum.DOOR_EVENT_LOADING, isLoading),

  setFaultsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.SET_LOADING_FAULTS, boolean> =>
    createAction(PdApiActionsEnum.SET_LOADING_FAULTS, isLoading),
  setStatisticsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.SET_LOADING_STATISTICS, boolean> =>
    createAction(PdApiActionsEnum.SET_LOADING_STATISTICS, isLoading)
  ,
  setLocalizationsPublishingStatus: (
    isPublishing: boolean
  ): ActionWithPayload<PdApiActionsEnum.SET_PUBLISHING_LOCALIZATIONS, boolean> =>
    createAction(PdApiActionsEnum.SET_PUBLISHING_LOCALIZATIONS, isPublishing),
  localizationPublishSucceeded: (
    completedAt: number
  ): ActionWithPayload<PdApiActionsEnum.LOCALIZATION_PUBLISH_SUCCEEDED, number> =>
    createAction(PdApiActionsEnum.LOCALIZATION_PUBLISH_SUCCEEDED, completedAt),
  setLicenseGenerationStatus: (
    isGenerating: boolean
  ): ActionWithPayload<PdApiActionsEnum.SET_LICENSE_GENERATION, boolean> =>
    createAction(PdApiActionsEnum.SET_LICENSE_GENERATION, isGenerating),
  setExportDevelopmentPackageStatus: (
    isExporting: boolean
  ): ActionWithPayload<PdApiActionsEnum.SET_EXPORTING_DEVELOPMENT_PACKAGE, boolean> =>
    createAction(PdApiActionsEnum.SET_EXPORTING_DEVELOPMENT_PACKAGE, isExporting),
  setDownloadEscalatorDevPackage: (
    isDownloading: boolean
  ): ActionWithPayload<PdApiActionsEnum.SET_DOWNLOADING_ESCALATOR_DEV_PACKAGE, boolean> =>
    createAction(PdApiActionsEnum.SET_DOWNLOADING_ESCALATOR_DEV_PACKAGE, isDownloading),
  setElectrifications: (
    electrifications: Api.Electrification[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ELECTRIFICATIONS, Api.Electrification[]> =>
    createAction(PdApiActionsEnum.SET_ELECTRIFICATIONS, electrifications),
  setFilterOptions: (
    object: State.FilterOptions
  ): ActionWithPayload<PdApiActionsEnum.SET_FILTER_OPTIONS, State.FilterOptions> =>
    createAction(PdApiActionsEnum.SET_FILTER_OPTIONS, object),
  setTranslationStatusFilterOptions: (
    object: State.TranslationStatusFilterOptions
  ): ActionWithPayload<
    PdApiActionsEnum.SET_TRANSLATION_STATUS_FILTER_OPTIONS,
    State.TranslationStatusFilterOptions
  > => createAction(PdApiActionsEnum.SET_TRANSLATION_STATUS_FILTER_OPTIONS, object),
  setAADGroups: (
    aadGroups: Api.AADGroup[]
  ): ActionWithPayload<PdApiActionsEnum.SET_AAD_GROUPS, Api.AADGroup[]> =>
    createAction(PdApiActionsEnum.SET_AAD_GROUPS, aadGroups),
  setLocales: (
    locales: Api.Locale[]
  ): ActionWithPayload<PdApiActionsEnum.SET_LOCALES, Api.Locale[]> =>
    createAction(PdApiActionsEnum.SET_LOCALES, locales),
  setTranslationLogItems: (
    translationLogItems: Api.TranslationLogItem[]
  ): ActionWithPayload<PdApiActionsEnum.SET_TRANSLATION_LOG_ITEMS, Api.TranslationLogItem[]> =>
    createAction(PdApiActionsEnum.SET_TRANSLATION_LOG_ITEMS, translationLogItems),
  setTranslationSummary: (
    translationSummary: Api.SeriesDataset[]
  ): ActionWithPayload<PdApiActionsEnum.SET_TRANSLATION_SUMMARY, Api.SeriesDataset[]> =>
    createAction(PdApiActionsEnum.SET_TRANSLATION_SUMMARY, translationSummary),
  setLanguageCoverage: (
    languageCoverage: Api.SeriesDataset[]
  ): ActionWithPayload<PdApiActionsEnum.SET_LANGUAGE_COVERAGE, Api.SeriesDataset[]> =>
    createAction(PdApiActionsEnum.SET_LANGUAGE_COVERAGE, languageCoverage),
  setItemTypeLanguageCoverage: (
    itemTypeLanguageCoverage: Api.ItemTypeSeriesDataset[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ITEMTYPE_LANGUAGE_COVERAGE, Api.ItemTypeSeriesDataset[]> =>
    createAction(PdApiActionsEnum.SET_ITEMTYPE_LANGUAGE_COVERAGE, itemTypeLanguageCoverage),
  setDoorEventClasses: (
    doorEventClasses: Api.EventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DOOR_EVENT_CLASSES, Api.EventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_DOOR_EVENT_CLASSES, doorEventClasses),
  setDoorEventTypes: (
    doorEventTypes: Api.EventTypesEnum[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DOOR_EVENT_TYPES, Api.EventTypesEnum[]> =>
    createAction(PdApiActionsEnum.SET_DOOR_EVENT_TYPES, doorEventTypes),
  setDoorEventPids: (
    doorEventPids: Api.EventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DOOR_EVENT_PIDS, Api.EventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_DOOR_EVENT_PIDS, doorEventPids),
  setDoorExtCommands: (
    doorExtCommands: Api.EventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DOOR_EXT_COMMANDS, Api.EventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_DOOR_EXT_COMMANDS, doorExtCommands),
  setEscalatorEventClasses: (
    EscalatorEventClasses: Api.EventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_EVENT_CLASSES, Api.EventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_EVENT_CLASSES, EscalatorEventClasses),
  setEscalatorEventTypes: (
    EscalatorEventTypes: Api.EventTypesEnum[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_EVENT_TYPES, Api.EventTypesEnum[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_EVENT_TYPES, EscalatorEventTypes),
  setEscalatorEventPids: (
    EscalatorEventPids: Api.EventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_EVENT_PIDS, Api.EventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_EVENT_PIDS, EscalatorEventPids),
  setEscalatorExtCommand: (
    EscalatorExtCommand: Api.EventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_EXT_COMMAND, Api.EventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_EXT_COMMAND, EscalatorExtCommand),
  setEscalatorRequestTypes: (
    EscalatorRequestTypes: Api.EventEnumeration[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_REQUEST_TYPES, Api.EventEnumeration[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_REQUEST_TYPES, EscalatorRequestTypes),  
  setDoorVersions: (
    DoorVersions: Api.DoorVersion[]
  ): ActionWithPayload<PdApiActionsEnum.SET_DOOR_VERSIONS, Api.DoorVersion[]> =>
    createAction(PdApiActionsEnum.SET_DOOR_VERSIONS, DoorVersions),
  setEscalatorVersions: (
    escalatorVersions: Api.EscalatorVersion[]
  ): ActionWithPayload<PdApiActionsEnum.SET_ESCALATOR_VERSIONS, Api.EscalatorVersion[]> =>
    createAction(PdApiActionsEnum.SET_ESCALATOR_VERSIONS, escalatorVersions),
  escalatorRTDLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.ESCALATOR_RTDS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.ESCALATOR_RTDS_LOADING, isLoading),
  escalatorRTDGroupLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.ESCALATOR_RTD_GROUPS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.ESCALATOR_RTD_GROUPS_LOADING, isLoading),
  escalatorEventLogLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.ESCALATOR_EVENT_LOGS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.ESCALATOR_EVENT_LOGS_LOADING, isLoading),
  fetchDataActCodes: (): Action<PdApiActionsEnum.FETCH_DATA_ACT_CODES> =>
    createAction(PdApiActionsEnum.FETCH_DATA_ACT_CODES),
  dataActCodesLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.DATAACT_CODE_LOADING, boolean> =>
    createAction(PdApiActionsEnum.DATAACT_CODE_LOADING, isLoading),
  escalatorDataActCodesLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.ESCALATOR_DATAACT_CODE_LOADING, boolean> =>
    createAction(PdApiActionsEnum.ESCALATOR_DATAACT_CODE_LOADING, isLoading),
  grandNormsLoadingStatus: (
    isLoading: boolean
  ): ActionWithPayload<PdApiActionsEnum.GRAND_NORMS_LOADING, boolean> =>
    createAction(PdApiActionsEnum.GRAND_NORMS_LOADING, isLoading),
  uploadTlgQa: (
    deviceType: string,
    userGroup: string,
    jsonContent: string
  ): ActionWithPayload<PdApiActionsEnum.UPLOAD_TLG_QA, { deviceType: string; userGroup: string; jsonContent: string }> =>
    createAction(PdApiActionsEnum.UPLOAD_TLG_QA, { deviceType, userGroup, jsonContent }),
  uploadTlgQaSuccess: (
    record: State.RecordMeta
  ): ActionWithPayload<PdApiActionsEnum.UPLOAD_TLG_QA_SUCCESS, State.RecordMeta> =>
    createAction(PdApiActionsEnum.UPLOAD_TLG_QA_SUCCESS, record),
  uploadTlgQaFailure: (
    error: string
  ): ActionWithPayload<PdApiActionsEnum.UPLOAD_TLG_QA_FAILURE, string> =>
    createAction(PdApiActionsEnum.UPLOAD_TLG_QA_FAILURE, error),
  fetchLicenseRecord: (
    deviceType: string,
    userGroup: string,
    db: "qa" | "prod" | "lota"
  ): ActionWithPayload<PdApiActionsEnum.FETCH_LICENSE_RECORD, { deviceType: string; userGroup: string; db: "qa" | "prod" | "lota" }> =>
    createAction(PdApiActionsEnum.FETCH_LICENSE_RECORD, { deviceType, userGroup, db }),
  fetchLicenseRecordSuccess: (
    db: "qa" | "prod" | "lota",
    record: State.RecordMeta | null,
    jsonContent: string | null
  ): ActionWithPayload<PdApiActionsEnum.FETCH_LICENSE_RECORD_SUCCESS, { db: "qa" | "prod" | "lota"; record: State.RecordMeta | null; jsonContent: string | null }> =>
    createAction(PdApiActionsEnum.FETCH_LICENSE_RECORD_SUCCESS, { db, record, jsonContent }),
  fetchLicenseRecordFailure: (
    db: "qa" | "prod" | "lota",
    error: string
  ): ActionWithPayload<PdApiActionsEnum.FETCH_LICENSE_RECORD_FAILURE, { db: "qa" | "prod" | "lota"; error: string }> =>
    createAction(PdApiActionsEnum.FETCH_LICENSE_RECORD_FAILURE, { db, error }),
  pushToProd: (
    deviceType: string,
    userGroup: string
  ): ActionWithPayload<PdApiActionsEnum.PUSH_TO_PROD, { deviceType: string; userGroup: string }> =>
    createAction(PdApiActionsEnum.PUSH_TO_PROD, { deviceType, userGroup }),
  pushToProdSuccess: (
    record: State.RecordMeta
  ): ActionWithPayload<PdApiActionsEnum.PUSH_TO_PROD_SUCCESS, State.RecordMeta> =>
    createAction(PdApiActionsEnum.PUSH_TO_PROD_SUCCESS, record),
  pushToProdFailure: (
    error: string
  ): ActionWithPayload<PdApiActionsEnum.PUSH_TO_PROD_FAILURE, string> =>
    createAction(PdApiActionsEnum.PUSH_TO_PROD_FAILURE, error),
  requestLota: (
    deviceType: string,
    userGroup: string,
    comment: string
  ): ActionWithPayload<PdApiActionsEnum.REQUEST_LOTA, { deviceType: string; userGroup: string; comment: string }> =>
    createAction(PdApiActionsEnum.REQUEST_LOTA, { deviceType, userGroup, comment }),
  requestLotaSuccess: (
    requestedBy: string,
    requestedAt: string
  ): ActionWithPayload<PdApiActionsEnum.REQUEST_LOTA_SUCCESS, { requestedBy: string; requestedAt: string }> =>
    createAction(PdApiActionsEnum.REQUEST_LOTA_SUCCESS, { requestedBy, requestedAt }),
  requestLotaFailure: (
    error: string
  ): ActionWithPayload<PdApiActionsEnum.REQUEST_LOTA_FAILURE, string> =>
    createAction(PdApiActionsEnum.REQUEST_LOTA_FAILURE, error),
  approveLota: (
    deviceType: string,
    userGroup: string
  ): ActionWithPayload<PdApiActionsEnum.APPROVE_LOTA, { deviceType: string; userGroup: string }> =>
    createAction(PdApiActionsEnum.APPROVE_LOTA, { deviceType, userGroup }),
  approveLotaSuccess: (
    record: State.RecordMeta
  ): ActionWithPayload<PdApiActionsEnum.APPROVE_LOTA_SUCCESS, State.RecordMeta> =>
    createAction(PdApiActionsEnum.APPROVE_LOTA_SUCCESS, record),
  approveLotaFailure: (
    error: string
  ): ActionWithPayload<PdApiActionsEnum.APPROVE_LOTA_FAILURE, string> =>
    createAction(PdApiActionsEnum.APPROVE_LOTA_FAILURE, error),
  rejectLota: (
    deviceType: string,
    userGroup: string,
    reason: string
  ): ActionWithPayload<PdApiActionsEnum.REJECT_LOTA, { deviceType: string; userGroup: string; reason: string }> =>
    createAction(PdApiActionsEnum.REJECT_LOTA, { deviceType, userGroup, reason }),
  rejectLotaSuccess: (
    rejectionReason: string
  ): ActionWithPayload<PdApiActionsEnum.REJECT_LOTA_SUCCESS, string> =>
    createAction(PdApiActionsEnum.REJECT_LOTA_SUCCESS, rejectionReason),
  rejectLotaFailure: (
    error: string
  ): ActionWithPayload<PdApiActionsEnum.REJECT_LOTA_FAILURE, string> =>
    createAction(PdApiActionsEnum.REJECT_LOTA_FAILURE, error),
  setLicenseDeviceType: (
    deviceType: string
  ): ActionWithPayload<PdApiActionsEnum.SET_LICENSE_DEVICE_TYPE, string> =>
    createAction(PdApiActionsEnum.SET_LICENSE_DEVICE_TYPE, deviceType),
  setLicenseUserGroup: (
    userGroup: string
  ): ActionWithPayload<PdApiActionsEnum.SET_LICENSE_USER_GROUP, string> =>
    createAction(PdApiActionsEnum.SET_LICENSE_USER_GROUP, userGroup),
};

export type PdApiActions = ActionsUnion<typeof pdApiActions>;
